import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "mb-16"
};
const _hoisted_2 = { class: "grid gap-6 sm:grid-cols-2 lg:grid-cols-3" };
import MenuCard from './MenuCard.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MenusSection',
    props: {
        menus: {}
    },
    emits: ["select-menu"],
    setup(__props) {
        return (_ctx, _cache) => {
            return (_ctx.menus.length)
                ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
                    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "mb-8" }, [
                        _createElementVNode("h2", { class: "text-3xl lg:text-4xl font-bold text-gray-900 mb-2 flex items-center" }, [
                            _createElementVNode("i", { class: "fas fa-layer-group mr-4 text-red-500" }),
                            _createTextVNode(" Menüs ")
                        ]),
                        _createElementVNode("p", { class: "text-gray-600 text-lg" }, "Sparen Sie mit unseren Kombi-Menüs")
                    ], -1 /* CACHED */)),
                    _createElementVNode("div", _hoisted_2, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (menu) => {
                            return (_openBlock(), _createBlock(MenuCard, {
                                key: menu.id,
                                menu: menu,
                                onSelect: ($event) => (_ctx.$emit('select-menu', menu))
                            }, null, 8 /* PROPS */, ["menu", "onSelect"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ])
                ]))
                : _createCommentVNode("v-if", true);
        };
    }
});
